
const EDLookupLayout = (customParams = {}) => ({
    valueExpr: 'codevalue',
    displayExpr: 'codevalue',
    sort: [{ selector: "codevalue", desc: false }],
    searchEnbabled: true,
    acceptCustomValue: true,
    gridKey: 'C91C6B98-1A2D-4EED-A3FE-977AF352F4A1',
    params: {
        module: "ED",
        lookupType: "Edelementcodes",
        showLookupGrid: true,
        ...customParams
    },
    columns: [
        { dataField: "dataelementnum", caption: "Element #", dataType: "string" },
        { dataField: "rank", caption: "Rank", dataType: "string" },
        { dataField: "codevalue", caption: "Code", dataType: "string" },
        { dataField: "userCode", caption: "User Code", dataType: "string" },
        { dataField: "description", caption: "Description", dataType: "string" },
        { dataField: "notes", caption: "Notes", dataType: "string" },

    ]
});

const EDHazardousLayout = (customParams = {}) => ({
    valueExpr: 'id',
    displayExpr: 'codevalue',
    sort: [{ selector: "codevalue", desc: false }],
    searchEnbabled: true,
    acceptCustomValue: true,
    gridKey: '1A1C689B-060A-4CA1-B6D9-B64807625057',
    params: {
        module: "ED",
        lookupType: "EDHazardous",
        showLookupGrid: true,
        ...customParams
    },
    columns: [
        { dataField: "id", caption: "Id", dataType: "number", visible: false },
        { dataField: "codevalue", caption: "Code", dataType: "string"},
        { dataField: "Record#", caption: "Key Sequence", dataType: "number", visible: false },
        { dataField: "creationdatetime", caption: "Creation Date", dataType: "datetime", visible: false },
        { dataField: "creationuserid", caption: "Created By", dataType: "string", visible: false },
        { dataField: "lastupdatedatetime", caption: "Last Update", dataType: "datetime", visible: false },
        { dataField: "lastupdateuserid", caption: "Lastupdated By", dataType: "string", visible: false },
        { dataField: "description", caption: "Description", dataType: "string"},
        { dataField: "unnaidentification", caption: "UN/NA ID#", dataType: "string" },
        { dataField: "packinggroup", caption: "Packing Group", dataType: "string"},
        { dataField: "subsidiaryriskindicator", caption: "Subsidiary Risk Indicator", dataType: "string", visible: false },
        { dataField: "specialcommodityindicatorcode", caption: "Special Commodity Indicator Code", dataType: "string", visible: false },
        { dataField: "comment", caption: "Comment", dataType: "string", visible: false },
        { dataField: "userdefinedcode1", caption: "Code 1", dataType: "string", visible: false },
        { dataField: "userdefinedcode2", caption: "Code 2", dataType: "string", visible: false },
        { dataField: "userdefinedcode3", caption: "Code 3", dataType: "string", visible: false },
        { dataField: "userdefinedcode4", caption: "Code 4", dataType: "string", visible: false },
        { dataField: "userdefinedcode5", caption: "Code 5", dataType: "string", visible: false },
        { dataField: "userdefinedcode6", caption: "Code 6", dataType: "string", visible: false },
        { dataField: "userdefinedcode7", caption: "Code 7", dataType: "string", visible: false },
        { dataField: "userdefinedcode8", caption: "Code 8", dataType: "string", visible: false },
        { dataField: "userdefinedcode9", caption: "Code 9", dataType: "string", visible: false },
        { dataField: "userdefinedcode10", caption: "Code 10", dataType: "string", visible: false },
        { dataField: "userdefinedreference1", caption: "Reference 1", dataType: "string", visible: false },
        { dataField: "userdefinedreference2", caption: "Reference 2", dataType: "string", visible: false },
        { dataField: "userdefinedreference3", caption: "Reference 3", dataType: "string", visible: false },
        { dataField: "userdefinedreference4", caption: "Reference 4", dataType: "string", visible: false },
        { dataField: "userdefinedreference5", caption: "Reference 5", dataType: "string", visible: false },
        { dataField: "userdefinedreference6", caption: "Reference 6", dataType: "string", visible: false },
        { dataField: "userdefinedreference7", caption: "Reference 7", dataType: "string", visible: false },
        { dataField: "userdefinedreference8", caption: "Reference 8", dataType: "string", visible: false },
        { dataField: "userdefinedreference9", caption: "Reference 9", dataType: "string", visible: false },
        { dataField: "userdefinedreference10", caption: "Reference 10", dataType: "string", visible: false },
        { dataField: "userdefinedcomment", caption: "Comment", dataType: "string", visible: false },
        { dataField: "placardnotation1", caption: "Placard Notn", dataType: "string", visible: false },
        { dataField: "placardnotation2", caption: "Placard Notn 2", dataType: "string", visible: false },
        { dataField: "placardnotation3", caption: "Placard Notn 3", dataType: "string", visible: false },
        { dataField: "placardnotation4", caption: "Placard Notn 4", dataType: "string", visible: false },
        { dataField: "placardendorsement", caption: "Placard Endrs", dataType: "string", visible: false },
        { dataField: "warninglabel", caption: "Warning Label", dataType: "string", visible: false },
        { dataField: "minimumreportingquantity", caption: "MINIMUM REPORTING QUANITY", dataType: "number", visible: false },
        { dataField: "epawastestreamnumber", caption: "Wase Stream #", dataType: "string", visible: false },
        { dataField: "epawastecharacteristics", caption: "Characteristics", dataType: "string", visible: false },
        { dataField: "epastate", caption: "State", dataType: "string", visible: false },
        { dataField: "epahazardouswastenumber", caption: "Hazardous Waste#", dataType: "string", visible: false },
        { dataField: "emergencyresponsepagenumber", caption: "Emergencyrespons", dataType: "string", visible: false },
        { dataField: "hazardclass1", caption: "Class 1", dataType: "string", visible: false },
        { dataField: "hazardclass2", caption: "Class 2", dataType: "string", visible: false },
        { dataField: "hazardclass3", caption: "Class 3", dataType: "string", visible: false },
        { dataField: "hazardclass4", caption: "Class 4", dataType: "string", visible: false },
        { dataField: "emergencyphone1", caption: "Tel Phone 1", dataType: "string", visible: false },
        { dataField: "emergencyphone2", caption: "Tel Phone 2", dataType: "string", visible: false },
        { dataField: "hazardousnotation", caption: "Hazardous Notn", dataType: "string", visible: false },
        { dataField: "emergencycontact1", caption: "Contact 1", dataType: "string", visible: false },
        { dataField: "emergencycontact2", caption: "Contact 2", dataType: "string", visible: false },
        { dataField: "minimumreportingquantityuom", caption: "MINIMUM REPORTING QUANTITY UOM", dataType: "string", visible: false },
        { dataField: "hazardousconstituents", caption: "Constituents", dataType: "string", visible: false },
        { dataField: "emergencyresponsephone1", caption: "Response Phone 1", dataType: "string", visible: false },
        { dataField: "emergencyresponsephone2", caption: "Response Phone 2", dataType: "string", visible: false },
        { dataField: "shippingname", caption: "Shipping Name", dataType: "string", visible: false },
        { dataField: "shippingnamecanadian", caption: "Canadian", dataType: "string", visible: false },
        { dataField: "shippingnameinternational", caption: "International", dataType: "string", visible: false },
        { dataField: "technicalname", caption: "Technical Name", dataType: "string", visible: false },
        { dataField: "userdefineddate1", caption: "Date 1", dataType: "date", visible: false },
        { dataField: "userdefineddate2", caption: "Date 2", dataType: "date", visible: false },
        { dataField: "userdefineddate3", caption: "Date 3", dataType: "date", visible: false },
        { dataField: "userdefineddate4", caption: "Date 4", dataType: "date", visible: false },
        { dataField: "userdefineddate5", caption: "Date 5", dataType: "date", visible: false },
        { dataField: "userdefineddate6", caption: "Date 6", dataType: "date", visible: false },
        { dataField: "userdefineddate7", caption: "Date 7", dataType: "date", visible: false },
        { dataField: "userdefineddate8", caption: "Date 8", dataType: "date", visible: false },
        { dataField: "userdefineddate9", caption: "Date 9", dataType: "date", visible: false },
        { dataField: "userdefineddate10", caption: "Date 10", dataType: "date", visible: false },
        { dataField: "userdefinedquantity1", caption: "Quantity 1", dataType: "number", visible: false },
        { dataField: "userdefinedquantity2", caption: "Quantity 2", dataType: "number", visible: false },
        { dataField: "userdefinedquantity3", caption: "Quantity 3", dataType: "number", visible: false },
        { dataField: "userdefinedquantity4", caption: "Quantity 4", dataType: "number", visible: false },
        { dataField: "userdefinedquantity5", caption: "Quantity 5", dataType: "number", visible: false },
        { dataField: "userdefinedquantity6", caption: "Quantity 6", dataType: "number", visible: false },
        { dataField: "userdefinedquantity7", caption: "Quantity 7", dataType: "number", visible: false },
        { dataField: "userdefinedquantity8", caption: "Quantity 8", dataType: "number", visible: false },
        { dataField: "userdefinedquantity9", caption: "Quantity 9", dataType: "number", visible: false },
        { dataField: "userdefinedquantity10", caption: "Quantity 10", dataType: "number", visible: false }

    ]

});

export {
    EDLookupLayout,
    EDHazardousLayout
}